import { Outlet } from "react-router-dom";

const PromotionRoot = () => {
  return (
    <div>
      <Outlet />
    </div>
  );
};

export default PromotionRoot;